module.exports = __webpack_public_path__ + "static/media/hdmi-img.1e6c40e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/hdmi-img.png
// module id = 1529
// module chunks = 1